import { useEffect } from "react";

const vendorScripts = [
  "/js/jquery-3.5.1.min.js",
  "/js/jquery-migrate-3.0.0.min.js",
  "/js/modernizr-2.6.2.min.js",
  "/js/imagesloaded.pkgd.min.js",
  "/js/jquery.isotope.v3.0.2.js",
  "/js/pace.js",
  "/js/popper.min.js",
  "https://cdn.jsdelivr.net/npm/smartwizard@5/dist/js/jquery.smartWizard.min.js",
  "/js/bootstrap.min.js",
  "/js/scrollIt.min.js",
  "/js/jquery.waypoints.min.js",
  "/js/owl.carousel.min.js",
  "/js/jquery.stellar.min.js",
  "/js/jquery.magnific-popup.js",
  "/js/YouTubePopUp.js",
  "/js/before-after.js",
];

const cssAssets = [
  "https://cdn.jsdelivr.net/npm/smartwizard@5/dist/css/smart_wizard_all.min.css",
  "/css/all.css",
  "/css/styleASS.css",
];

function ensureAssessmentCss() {
  cssAssets.forEach((href) => {
    const selector = `link[data-legacy-assessment-css="${href}"]`;
    if (document.querySelector(selector)) return;

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.setAttribute("data-legacy-assessment-css", href);
    document.head.appendChild(link);
  });
}

function loadScript(src, { bust = false, mark = false } = {}) {
  return new Promise((resolve, reject) => {
    const el = document.createElement("script");
    el.src = bust ? `${src}?v=${Date.now()}` : src;
    el.async = false;
    if (mark) {
      el.setAttribute("data-legacy-src", src);
    }
    el.onload = () => resolve(true);
    el.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.body.appendChild(el);
  });
}

function ensureVendorScriptsLoaded() {
  const existing = new Set(
    Array.from(document.querySelectorAll("script[data-legacy-src]"))
      .map((s) => s.getAttribute("data-legacy-src"))
      .filter(Boolean)
  );

  return vendorScripts.reduce((p, src) => {
    if (existing.has(src)) return p;
    return p.then(() => loadScript(src, { mark: true }));
  }, Promise.resolve());
}

export default function useLegacyAssessmentScripts(enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;
    ensureAssessmentCss();

    (async () => {
      try {
        await ensureVendorScriptsLoaded();
        if (cancelled) return;
        await loadScript("/js/assessment-wizard.js", { bust: true });
        if (cancelled) return;
        await loadScript("/js/custom.js", { bust: true });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("[legacy-assessment-scripts] init issue:", e);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled]);
}
